import React from 'react';
import styled from 'styled-components';

const StyledRow = styled.div`
  display: flex;
  flex-direction: row;
  margin: -1rem 0 0 -1rem;
  flex-grow: 1;
  width: calc(100% + 2rem);
  @media screen and (max-width: 640px) {
    > div {
      flex: auto;
    }
  }
`;

export const CustomRow = (props: any) => {
  return <StyledRow {...props} />;
};
